/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Schule_Und_Internat_Steinmuhle4Inputs */

const en__field__enum_schoolname_schule_und_internat_steinmuhle4 = /** @type {(inputs: _Field__Enum_Schoolname_Schule_Und_Internat_Steinmuhle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marburg`)
};

const de__field__enum_schoolname_schule_und_internat_steinmuhle4 = /** @type {(inputs: _Field__Enum_Schoolname_Schule_Und_Internat_Steinmuhle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schule und Internat Steinmühle`)
};

/**
* | output |
* | --- |
* | "Marburg" |
*
* @param {_Field__Enum_Schoolname_Schule_Und_Internat_Steinmuhle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_schule_und_internat_steinmuhle4 = /** @type {((inputs?: _Field__Enum_Schoolname_Schule_Und_Internat_Steinmuhle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Schule_Und_Internat_Steinmuhle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_schule_und_internat_steinmuhle4(inputs)
	return de__field__enum_schoolname_schule_und_internat_steinmuhle4(inputs)
});
export { _field__enum_schoolname_schule_und_internat_steinmuhle4 as "_field__enum_schoolName_Schule_und_Internat_Steinmuhle" }